(function () {
  function initOneSlideClamp(galleryUl) {
    if (!galleryUl || galleryUl.dataset.oneSlideClamp === "1") return;
    galleryUl.dataset.oneSlideClamp = "1";

    const getSlides = () => Array.from(galleryUl.querySelectorAll(":scope > li"));
    const getOffsets = () => getSlides().map((li) => li.offsetLeft);

    const nearestIndex = (offsets, scrollLeft) => {
      let best = 0;
      let bestDist = Infinity;
      for (let i = 0; i < offsets.length; i++) {
        const d = Math.abs(offsets[i] - scrollLeft);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return best;
    };

    let startIndex = 0;
    let startX = 0;
    let dragging = false;

    // Capture starting slide on touch start
    galleryUl.addEventListener(
      "touchstart",
      (e) => {
        const offsets = getOffsets();
        if (!offsets.length) return;

        dragging = true;
        startX = e.touches?.[0]?.clientX ?? 0;
        startIndex = nearestIndex(offsets, galleryUl.scrollLeft);
      },
      { passive: true }
    );

    // On touch end, clamp jump to at most 1 slide
    galleryUl.addEventListener(
      "touchend",
      (e) => {
        if (!dragging) return;
        dragging = false;

        const offsets = getOffsets();
        if (!offsets.length) return;

        // Let theme finish its momentum/animation first
        window.setTimeout(() => {
          const currentIndex = nearestIndex(offsets, galleryUl.scrollLeft);
          const diff = currentIndex - startIndex;

          if (Math.abs(diff) > 1) {
            const endX = e.changedTouches?.[0]?.clientX ?? startX;
            const dir = diff !== 0 ? Math.sign(diff) : (endX < startX ? 1 : -1);
            const targetIndex = Math.max(0, Math.min(offsets.length - 1, startIndex + dir));

            galleryUl.scrollTo({ left: offsets[targetIndex], behavior: "smooth" });
          }
        }, 80);
      },
      { passive: true }
    );
  }

  function boot() {
    // Your exact element from the screenshot:
    document
      .querySelectorAll("media-gallery ul.media-gallery__grid, media-gallery ul.media-gallery__grid.list-unstyled")
      .forEach(initOneSlideClamp);
  }

  document.addEventListener("DOMContentLoaded", boot);

  // In case product section loads via JS (variant changes, quick view, etc.)
  const mo = new MutationObserver(() => boot());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();